require('initializers/gettext').default(__TRANSLATIONS__.gettext.hu); // eslint-disable-line no-undef
require('initializers/i18n').default('hu', __TRANSLATIONS__.i18n.hu); // eslint-disable-line no-undef

require('locales/dependencies');

require('select2/dist/js/i18n/hu');
require('jquery-ui/ui/i18n/datepicker-hu');
require('dayjs/locale/hu');
